import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';

const MentionsLegales = (props) => {
  return (
      <div>
              <Header />
  
   <div id="activites">

      <div className="container">
                           <div className="col-xs-12 col-md-12">

<br></br>
<br></br>
        <div className="section-title">
          <h2>Mentions légales – DELPHIA PAUL (Artisan Fleuriste)</h2>
          <br></br>
              <br></br>
                    <br></br>

                     <div className="activites-list" >        

      <section>
        <h3>1. Identification de l’éditeur et du responsable de la publication</h3>
        <p><strong>Nom de l’entreprise : </strong>DELPHIA PAUL</p>
        <p><strong>Forme juridique :</strong> Entrepreneur individuel (micro-entreprise)</p>
        <p><strong>SIREN :</strong> 982 966 913</p>
        <p><strong>SIRET du siège social :</strong> 982 966 913 00013</p>
        <p><strong>Adresse :</strong> 21 Rue Aristide Briand, 94430 Chennevières-sur-Marne, France</p>
        <p><strong>Activité (NAF/APE) :</strong> 47.76Z – Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé</p>
        <p><strong>Responsable de la publication : </strong>PAUL Delphia</p>
        <p><strong>Email :</strong> <a href="mailto:contact.jdp@delphiapaul.fr">contact.jdp@delphiapaul.fr</a></p>
        <p><strong>Téléphone :</strong> <a href="tel:+33625006753">06 25 00 67 53</a></p>
      </section>
<br></br>
      <section>
        <h3>2. Hébergement du site</h3>
        <p><strong>Hébergeur :</strong> NETLIFY</p>
        <p><strong>Société :</strong> NETLIFY – SAS au capital de 100 000 €</p>
        <p><strong>Adresse :</strong> 44 Montgomery St STE 300, San Francisco, Californie, États-Unis</p>
        <p><strong>Téléphone :</strong> <a href="tel:+1 415-691-1573">+1 415-691-1573</a></p>
        <p>
          <strong>Site web :</strong>{" "}
          <a href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer">
            https://www.netlify.com/
          </a>
        </p>
      </section>
<br></br>

      <section>
        <h3>3. Droits d’auteur et propriété intellectuelle</h3>
        <p>
          L’ensemble du contenu du site (textes, images, graphismes, logos, vidéos, éléments visuels, etc.) est protégé par le droit d’auteur et la législation sur la propriété intellectuelle.
        </p>
        <p>
          Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable de DELPHIA PAUL, est strictement interdite.
        </p>
      </section>
<br></br>

      <section>
        <h3>4. Protection des données personnelles</h3>
        <p>
          Aucune donnée personnelle n’est collectée sans votre consentement.
        </p>
        <p>
          Les données transmises via les formulaires (contact, demande, devis) sont utilisées exclusivement dans le cadre de l’activité de DELPHIA PAUL et ne sont jamais vendues ou cédées à des tiers.
        </p>
<br></br>

        <h3>Droits RGPD</h3>
        <ul>
          <li>Accès</li>
          <li>Rectification</li>
          <li>Suppression</li>
          <li>Limitation du traitement</li>
          <li>Opposition</li>
          <li>Portabilité</li>
        </ul>
<br></br>
        <p>
          Pour toute demande :
          <br></br>
          <br></br>
          📩 <a href="mailto:contact.jdp@delphiapaul.fr">contact.jdp@delphiapaul.fr</a>
<br></br>       📍 21 Rue Aristide Briand, 94430 Chennevières-sur-Marne
        </p>

        <p>
          Vous pouvez également saisir la CNIL en cas de litige.
        </p>
      </section>
<br></br>

      <section>
        <h3>5. Liens hypertextes</h3>
        <p>
          Toute création d’un lien hypertexte vers ce site doit faire l’objet d’une autorisation préalable du responsable de la publication.
        </p>
        <p>
          Le site peut contenir des liens vers des sites externes. DELPHIA PAUL décline toute responsabilité concernant le contenu ou le fonctionnement de ces sites tiers.
        </p>
      </section>
<br></br>

      <section>
        <h3>6. Limitation de responsabilité</h3>
        <p>
          DELPHIA PAUL s’efforce de fournir des informations exactes et mises à jour.
        </p>
        <p>
          Toutefois, aucune garantie n’est donnée quant à l’exactitude, l’exhaustivité ou l’actualité des informations présentes sur le site.
        </p>
        <p>
          L’éditeur se réserve le droit de modifier le contenu à tout moment, sans préavis. Il ne pourra être tenu responsable des dommages directs ou indirects résultant de l’utilisation du site.
        </p>
      </section>
  </div>
     </div>
     </div></div>
     </div>
        <Footer />
  
      </div>
    );
  };
export default MentionsLegales;